import ServerDirections from '@/config/server-directions'
import { RequestService } from '@/services/request.service'
import { ActivityCategory } from '@/entities/activities/ActivityCategory'
import { Activity } from '@/entities/activities/Activity'
import { ReservationMethod, AttendeeType } from '@/entities/activities/ReservationMethod'
import { WorkingHours } from '@/entities/activities/WorkingHours'
import { Slot } from '@/entities/activities/Slot'
import { ActivityGroup } from '@/entities/activities/ActivityGroup'
import { SlotCapacity } from '@/entities/activities/SlotCapacity'
import { CatalogWithCategoriesAndProducts } from '@/entities/Catalog'
import moment from 'moment'
const requestService = new RequestService()

export class ActivitiesRequests {
  listActivityCategories () {
    const route = ServerDirections.ACTIVITY_CATEGORIES
    const method = 'get'
    function map (data) {
      return data.map((item) => {
        return new ActivityCategory(item)
      })
    }
    return requestService.makePromise(route, method, {}, map)
  }
  listActivities () {
    const route = ServerDirections.ACTIVITIES
    const method = 'get'
    function map (data) {
      return data.map((item) => {
        return {
          activity: new Activity(item.activity, item.related_activities ? item.related_activities.map(a => new Activity(a)) : []),
          reservationMethods: item.reservation_methods.map(reservationMethod => {
            return {
              reservationMethod: new ReservationMethod(reservationMethod.activity_reservation_method),
              attendeeTypes: reservationMethod.attendee_types.map((attendeeType) => {
                return new AttendeeType(attendeeType)
              }),
              activityGroup: reservationMethod.activity_group ? new ActivityGroup(reservationMethod.activity_group) : null,
            }
          }),
        }
      })
    }
    return requestService.makePromise(route, method, {}, map)
  }
  getActivity (id) {
    const route = ServerDirections.ACTIVITIES_ID.replace('{activityId}', id)
    const method = 'get'
    function map (data) {
      return {
        activity: new Activity(data.activity, data.related_activities ? data.related_activities.map(a => new Activity(a)) : []),
        reservationMethods: data.reservation_methods
          .filter(rM => rM.activity_reservation_method.active)
          .map(rM => {
            const reservationMethod = new ReservationMethod(rM.activity_reservation_method)
            return {
              reservationMethod: reservationMethod.decorateCurrencies(data.currencies),
              attendeeTypes: rM.attendee_types.map((aT) => {
                const attendeeType = new AttendeeType(aT)
                return attendeeType.decorateCurrencies(data.currencies)
              }),
              activityGroup: rM.activity_group ? new ActivityGroup(rM.activity_group) : null,
            }
          }),
      }
    }
    return requestService.makePromise(route, method, {}, map)
  }
  getWorkingHours (id, { start, end, date }) {
    const route = ServerDirections.ACTIVITY_ID_WORKING_HOURS.replace('{activityId}', id)
    const method = 'get'
    function map (data) {
      return data.map((item) => {
        return new WorkingHours(item)
      })
    }
    var params = {}
    if (date) {
      params.start_date = date
      params.end_date = date
    } else {
      params.start_date = start
      params.end_date = end
    }
    return requestService.makePromise(route, method, { params }, map)
  }
  getSlots (id, date) {
    const route = ServerDirections.ACTIVITY_ID_SLOTS.replace('{activityId}', id)
    const method = 'get'
    function map (data) {
      return new Slot(data)
    }
    const params = {
      date: moment(date, 'YYYY-MM-DD').format('YYYY-MM-DDTHH:mm:ss.SSS+0000'),
    }
    return requestService.makePromise(route, method, { params }, map)
  }
  listCapacityPerSlot (id, since, until) {
    const route = ServerDirections.ACTIVITY_ID_SLOTS_CAPACITY.replace('{activityId}', id)
    const method = 'get'
    function map (data) {
      return data.map(item => new SlotCapacity(item))
    }
    const params = { since, until }
    return requestService.makePromise(route, method, { params }, map)
  }
  getCatalog (activityId) {
    const route = ServerDirections.ACTIVITY_ID_CATALOG.replace('{activityId}', activityId)
    const method = 'get'
    function map (data) {
      return new CatalogWithCategoriesAndProducts(data)
    }
    return requestService.makePromise(route, method, {}, map)
  }
}
